export const LOGO_URL = "/logo-bspark-kids.png";

export const LogoBspark = ({ className = "h-12", texto = false, testid = "logo-bspark" }) => (
  <span className="inline-flex items-center gap-3" data-testid={testid}>
    <img src={LOGO_URL} alt="Bspark Kids" className={`${className} w-auto object-contain`} />
    {texto && <span className="font-display font-extrabold text-xl tracking-tight">FamilyHub</span>}
  </span>
);
